import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import LoadingFeedback from "@widget/loaders/LoadingFeedback";
import LoadingFeedbackContext from "./LoadingFeedbackContext";
const LoadingFeedbackProvider = (props) => {
    // Use state to trigger re-renders and ref to manage loading state
    const [forceRender, setForceRender] = React.useState(false);
    const loadingRef = React.useRef(null);
    // Update loading state and trigger re-render
    const updateLoading = (newState) => {
        loadingRef.current = newState;
        setForceRender((prev) => !prev);
    };
    // Show loading feedback
    const show = React.useCallback((options) => {
        updateLoading({
            show: true,
            message: (options === null || options === void 0 ? void 0 : options.message) || 'Loading...',
            submessage: options === null || options === void 0 ? void 0 : options.submessage,
            progress: options === null || options === void 0 ? void 0 : options.progress,
            icon: options === null || options === void 0 ? void 0 : options.icon,
        });
    }, []);
    // Hide loading feedback
    const hide = React.useCallback(() => {
        updateLoading(null);
    }, []);
    // Update loading feedback (while visible)
    const update = React.useCallback((options) => {
        if (loadingRef.current) {
            updateLoading({
                show: true,
                message: options.message || loadingRef.current.message,
                submessage: options.submessage !== undefined ? options.submessage : loadingRef.current.submessage,
                progress: options.progress !== undefined ? options.progress : loadingRef.current.progress,
                icon: options.icon !== undefined ? options.icon : loadingRef.current.icon,
            });
        }
    }, []);
    // Provider value
    const providerValue = React.useMemo(() => ({ show, hide, update }), [show, hide, update]);
    return (_jsxs(LoadingFeedbackContext.Provider, { value: providerValue, children: [loadingRef.current && _jsx(LoadingFeedback, Object.assign({}, loadingRef.current)), props.children] }));
};
export default LoadingFeedbackProvider;
